export interface ConversionCategory {
    id: string;
    name: string;
    icon: string;
    units: {
        id: string;
        name: string;
        symbol: string;
    }[];
    convert: (value: number, from: string, to: string) => number;
}

// 냉동 능력 변환
const coolingConvert = (value: number, from: string, to: string): number => {
    // 기준: kW
    const toKw: Record<string, number> = {
        kw: 1,
        rt: 3.517,
        kcalh: 0.001163,
        hp: 0.746,
        btuh: 0.000293,
    };

    const kw = value * toKw[from];
    return kw / toKw[to];
};

// 압력 변환
const pressureConvert = (value: number, from: string, to: string): number => {
    // 기준: bar
    const toBar: Record<string, number> = {
        bar: 1,
        psi: 0.0689476,
        kpa: 0.01,
        mpa: 10,
        kgcm2: 0.980665,
        atm: 1.01325,
    };

    const bar = value * toBar[from];
    return bar / toBar[to];
};

// 온도 변환
const temperatureConvert = (value: number, from: string, to: string): number => {
    let celsius: number;

    // to celsius
    switch (from) {
        case 'c': celsius = value; break;
        case 'f': celsius = (value - 32) * 5 / 9; break;
        case 'k': celsius = value - 273.15; break;
        default: celsius = value;
    }

    // from celsius
    switch (to) {
        case 'c': return celsius;
        case 'f': return celsius * 9 / 5 + 32;
        case 'k': return celsius + 273.15;
        default: return celsius;
    }
};

// 길이 변환
const lengthConvert = (value: number, from: string, to: string): number => {
    // 기준: mm
    const toMm: Record<string, number> = {
        mm: 1,
        cm: 10,
        m: 1000,
        inch: 25.4,
        ft: 304.8,
    };

    const mm = value * toMm[from];
    return mm / toMm[to];
};

export const conversionCategories: ConversionCategory[] = [
    {
        id: 'cooling',
        name: '냉동 능력',
        icon: '❄️',
        units: [
            { id: 'kw', name: 'kW', symbol: 'kW' },
            { id: 'rt', name: 'RT (냉동톤)', symbol: 'RT' },
            { id: 'kcalh', name: 'kcal/h', symbol: 'kcal/h' },
            { id: 'hp', name: 'HP (마력)', symbol: 'HP' },
            { id: 'btuh', name: 'BTU/h', symbol: 'BTU/h' },
        ],
        convert: coolingConvert,
    },
    {
        id: 'pressure',
        name: '압력',
        icon: '💨',
        units: [
            { id: 'bar', name: 'bar', symbol: 'bar' },
            { id: 'psi', name: 'psi', symbol: 'psi' },
            { id: 'kpa', name: 'kPa', symbol: 'kPa' },
            { id: 'mpa', name: 'MPa', symbol: 'MPa' },
            { id: 'kgcm2', name: 'kg/cm²', symbol: 'kg/cm²' },
            { id: 'atm', name: 'atm', symbol: 'atm' },
        ],
        convert: pressureConvert,
    },
    {
        id: 'temperature',
        name: '온도',
        icon: '🌡️',
        units: [
            { id: 'c', name: '섭씨', symbol: '°C' },
            { id: 'f', name: '화씨', symbol: '°F' },
            { id: 'k', name: '절대온도', symbol: 'K' },
        ],
        convert: temperatureConvert,
    },
    {
        id: 'length',
        name: '길이/관경',
        icon: '📏',
        units: [
            { id: 'mm', name: 'mm', symbol: 'mm' },
            { id: 'cm', name: 'cm', symbol: 'cm' },
            { id: 'm', name: 'm', symbol: 'm' },
            { id: 'inch', name: 'inch', symbol: '"' },
            { id: 'ft', name: 'feet', symbol: "'" },
        ],
        convert: lengthConvert,
    },
];